
import { Injectable } from '@angular/core';
import {
    HttpEvent, HttpRequest, HttpHandler,
    HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UtilsService } from '@shared/services/utils.service';
import { LoginService } from '@security/services/login.service';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { UserService } from '@shared/services/user.service';
const statusErrorsConfigs = require('@configs/status-errors.json');

@Injectable({
    providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {

    statusErrors: any;
    isInProduction: boolean = false;

    constructor(
        private utils: UtilsService,
        private loginService: LoginService,
        private userService: UserService
    ) {
        this.statusErrors = statusErrorsConfigs.status;
        this.isInProduction = environment.production;
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                const status = this.statusErrors.find(({ status }) => status == error.status);

                if (status) {

                    const errorInfo = error.error || {};
                    this.utils.openModal('error', {
                        errorCode: errorInfo.code || 'default'
                    });

                    return throwError(error);

                } else {
                    return throwError(error);
                }
            })
        );
    }
}